import {
   MedicalInformation,
   MedicalInformationQuery,
   MedicalInformationType,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { medicalDataTranslationKeys } from '../../translations';
import { SidePanelLoader } from '../SidePanelLoader';

const DEFAULT_PAGINATION = paginations.all<MedicalInformation>().orderedBy('creationDate', Direction.DESCENDING);

type MedicalDataSidePanelListLoaderRenderer = (renderProps: {
   medicalInformation: MedicalInformation[];
   refreshMedicalInformation: VoidFunction;
}) => JSX.Element;

type MedicalDataSidePanelListLoaderProps = {
   readonly patientId: number;
   readonly medicalInformationType: MedicalInformationType;
   readonly children: MedicalDataSidePanelListLoaderRenderer;
};

export const MedicalDataSidePanelListLoader = (props: MedicalDataSidePanelListLoaderProps): JSX.Element => {
   const {
      data: medicalInformation,
      loading: medicalInformationLoading,
      error: medicalInformationError,
      refetch: refreshMedicalInformation,
   } = useCqrsSearch<MedicalInformation>(() => {
      const query = new MedicalInformationQuery();
      query.patientId = Slot.emptyIfNull(props.patientId);
      query.type = Slot.emptyIfNull(props.medicalInformationType);
      return query;
   }, DEFAULT_PAGINATION);

   if (medicalInformationLoading) {
      return <SidePanelLoader />;
   }

   if (medicalInformationError) {
      return (
         <Message
            testId={'failedToFetchMedicalInformation'}
            label={medicalDataTranslationKeys.failedToFetchMedicalInformation}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      medicalInformation: medicalInformation,
      refreshMedicalInformation: refreshMedicalInformation,
   });
};
